export default __webpack_public_path__ + "static/media/jamie-text-editor-new-features.94ec3366.gif";